import * as React from 'react';
import Typography from '../sushi/Typography';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCopy } from '@fortawesome/pro-regular-svg-icons';
import { palette } from 'theme/palette';
import { styled } from 'stitches.config';


export const SimulatorShareResult = () => {
  const { formatMessage } = useIntl();
  const [isCopied, setIsCopied] = React.useState<boolean>(false);
  
    return (
      <ShareButton
        onClick={() => {
          navigator.clipboard.writeText(window.location.href);
          setIsCopied(true);
        }}>
        <Typography variant="bodyS" color="secondaryAlt">
          {formatMessage({ id: 'wealth_simulator.copy_url' })}
        </Typography>
        <FontAwesomeIcon
          color={palette.brand500}
          icon={isCopied ? faCheck : faCopy}
          width={14}
          height={20}
        />
      </ShareButton>
    )
}

const ShareButton = styled('button', {
    display: 'flex',
    margin: '0 auto',
    gap: '$2',
    '> *:first-child': {
      color: '$borderSelected !important',
    },
    svg: {
      paddingTop: '2px',
    },
  });